module.exports = __webpack_public_path__ + "img/savology-wf-2.b8a0c992.png";